import { render, staticRenderFns } from "./TongueReport.vue?vue&type=template&id=f29ee36c&scoped=true"
import script from "./TongueReport.vue?vue&type=script&lang=js"
export * from "./TongueReport.vue?vue&type=script&lang=js"
import style0 from "./TongueReport.vue?vue&type=style&index=0&id=f29ee36c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29ee36c",
  null
  
)

export default component.exports